// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__BnZou","bigColWidth":"Table_bigColWidth__3z9jE","biggerColWidth":"Table_biggerColWidth__c8XwY","row":"Table_row__3z1Sd","col":"Table_col__BBVFd"};